import * as HttpService from './http.service';
import * as URL from './url.service';

export const updateActivityLog = (data) => HttpService.putWithAuth(URL.UPDATE_ACTIVITY_LOG_URL(), data);

export const getActivityLog = (resourceId, status, offset, limit) => HttpService.getWithAuth(URL.GET_ACTIVITY_LOG_URL(resourceId, status, offset, limit));

export const getInreviewActivityLog = (offset, limit, search, sort, filters) => HttpService.getWithAuth(
    URL.GET_IN_REVIEW_ACTIVITY_LOG_URL(offset, limit, search, sort, filters)
);

export const exportProfileApprovalCsv = ({ search, filters, sort, status, type } = {}) =>
    HttpService.getWithAuth(URL.GET_PROFILE_APPROVAL_CSV({ search, filters, sort, status, type }));
